// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../app/assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../app/assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../app/assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../app/assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../app/assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../app/assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../app/assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../app/assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../app/assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.ForgotPassword_scroll__K4EXS::-webkit-scrollbar {
  height: 8px;
}
.ForgotPassword_scroll__K4EXS::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.ForgotPassword_scroll__K4EXS::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.ForgotPassword_SignIn__Iu1dd {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.ForgotPassword_SignIn__Iu1dd > svg {
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(-36%, -28%);
  width: 65%;
  z-index: -1;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_loginBox__UWLKk {
  max-width: 762px;
  width: 762px;
  background-color: var(--bgColor);
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ForgotPassword_SignIn__Iu1dd.ForgotPassword_succecs__AB7q6 .ForgotPassword_alert__hu4WB {
  transform: translateX(-50%) translateY(0);
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_alert__hu4WB {
  width: 366px;
  height: 30px;
  background-color: rgba(var(--secondaryColorRGB), 0.2);
  border: 1px solid var(--secondaryColor);
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-100%);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s;
  font-size: 12px;
  color: var(--mainColor);
}
@media (max-width: 480px) {
  .ForgotPassword_SignIn__Iu1dd .ForgotPassword_alert__hu4WB {
    width: 300px;
  }
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_form__XhwhO {
  max-width: 760px;
  padding: 100px 132px;
  background-color: var(--bgColor);
  color: var(--mainColor);
  width: 100%;
}
@media (max-width: 767px) {
  .ForgotPassword_SignIn__Iu1dd .ForgotPassword_form__XhwhO {
    padding: 50px;
  }
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_top__tccoO p {
  font-size: 14px !important;
  font-family: inherit;
  margin-bottom: 10px;
  color: currentColor;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_top__tccoO span {
  display: block;
  font-size: 14px;
  margin-bottom: 30px;
  color: currentColor;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_field__EWl-- .ForgotPassword_field_top__3ta54 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_field__EWl-- .ForgotPassword_field_top__3ta54 label {
  display: block;
  font-size: 12px;
  color: currentColor;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_field__EWl-- .ForgotPassword_field_top__3ta54 span {
  color: var(--errorColor);
  font-size: 12px;
  display: none;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_field__EWl--.ForgotPassword_errors__WaNwY label,
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_field__EWl--.ForgotPassword_errors__WaNwY span {
  color: var(--errorColor);
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_field__EWl--.ForgotPassword_errors__WaNwY span {
  display: inline;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_field__EWl--.ForgotPassword_errors__WaNwY input {
  border-color: var(--errorColor);
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_field__EWl-- input {
  display: block;
  padding: 0 15px;
  height: 40px;
  width: 100%;
  border: 1px solid var(--borderColor);
  margin-bottom: 30px;
  transition: 0.5s;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_field__EWl-- input:focus {
  outline: none !important;
  border-color: var(--secondaryColor);
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_button_Box__Uo\\+Ef {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_button_Box__Uo\\+Ef button {
  width: 130px;
  height: 40px;
  background-color: var(--secondaryColor);
  font-size: 12px;
  color: var(--bgColor);
  border: 1px solid var(--secondaryColor);
  cursor: pointer;
  transition: 0.5s;
  font-family: inherit;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_button_Box__Uo\\+Ef button:hover {
  background-color: transparent;
  color: var(--secondaryColor);
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_button_Box__Uo\\+Ef a {
  color: var(--secondaryColor);
  font-size: 12px !important;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_emailSent__WaL1v {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.ForgotPassword_SignIn__Iu1dd .ForgotPassword_emailSent__WaL1v p {
  font-size: 16px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/auth/pages/ForgotPassword/ForgotPassword.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAsDF;AArDE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;AAuDJ;AApDE;EACE,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAsDJ;AAlDI;EACE,yCAAA;AAoDN;AAhDE;EACE,YAAA;EACA,YAAA;EACA,qDAAA;EACA,uCAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AAkDJ;AAhDI;EAhBF;IAiBI,YAAA;EAmDJ;AACF;AAhDE;EACE,gBAAA;EACA,oBAAA;EACA,gCAAA;EACA,uBAAA;EACA,WAAA;AAkDJ;AAhDI;EAPF;IAQI,aAAA;EAmDJ;AACF;AA/CI;EACE,0BAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;AAiDN;AA9CI;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AAgDN;AA3CI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AA6CN;AA3CM;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AA6CR;AA1CM;EACE,wBAAA;EACA,eAAA;EACA,aAAA;AA4CR;AAvCM;;EAEE,wBAAA;AAyCR;AAtCM;EACE,eAAA;AAwCR;AArCM;EACE,+BAAA;AAuCR;AAnCI;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;AAqCN;AAnCM;EACE,wBAAA;EACA,mCAAA;AAqCR;AAhCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAkCJ;AAjCI;EACE,YAAA;EACA,YAAA;EACA,uCAAA;EACA,eAAA;EACA,qBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAmCN;AAjCM;EACE,6BAAA;EACA,4BAAA;AAmCR;AAhCI;EACE,4BAAA;EDhDF,0BAAA;ACmFJ;AA9BE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAgCJ;AA9BI;EACE,0BAAA;AAgCN","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.SignIn {\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  > svg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    transform: translate(-36%, -28%);\n    width: 65%;\n    z-index: -1;\n  }\n\n  .loginBox {\n    max-width: 762px;\n    width: 762px;\n    background-color: var(--bgColor);\n    min-height: 400px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &.succecs {\n    .alert {\n      transform: translateX(-50%) translateY(0);\n    }\n  }\n\n  .alert {\n    width: 366px;\n    height: 30px;\n    background-color: rgba(var(--secondaryColorRGB), 0.2);\n    border: 1px solid var(--secondaryColor);\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%) translateY(-100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: 0.5s;\n    font-size: 12px;\n    color: var(--mainColor);\n\n    @media (max-width: 480px) {\n      width: 300px;\n    }\n  }\n\n  .form {\n    max-width: 760px;\n    padding: 100px 132px;\n    background-color: var(--bgColor);\n    color: var(--mainColor);\n    width: 100%;\n\n    @media (max-width: 767px) {\n      padding: 50px;\n    }\n  }\n\n  .top {\n    p {\n      font-size: 14px !important;\n      font-family: inherit;\n      margin-bottom: 10px;\n      color: currentColor;\n    }\n\n    span {\n      display: block;\n      font-size: 14px;\n      margin-bottom: 30px;\n      color: currentColor;\n    }\n  }\n\n  .field {\n    .field_top {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding-bottom: 10px;\n\n      label {\n        display: block;\n        font-size: 12px;\n        color: currentColor;\n      }\n\n      span {\n        color: var(--errorColor);\n        font-size: 12px;\n        display: none;\n      }\n    }\n\n    &.errors {\n      label,\n      span {\n        color: var(--errorColor);\n      }\n\n      span {\n        display: inline;\n      }\n\n      input {\n        border-color: var(--errorColor);\n      }\n    }\n\n    input {\n      display: block;\n      padding: 0 15px;\n      height: 40px;\n      width: 100%;\n      border: 1px solid var(--borderColor);\n      margin-bottom: 30px;\n      transition: 0.5s;\n\n      &:focus {\n        outline: none !important;\n        border-color: var(--secondaryColor);\n      }\n    }\n  }\n\n  .button_Box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 20px;\n    button {\n      width: 130px;\n      height: 40px;\n      background-color: var(--secondaryColor);\n      font-size: 12px;\n      color: var(--bgColor);\n      border: 1px solid var(--secondaryColor);\n      cursor: pointer;\n      transition: 0.5s;\n      font-family: inherit;\n\n      &:hover {\n        background-color: transparent;\n        color: var(--secondaryColor);\n      }\n    }\n    a {\n      color: var(--secondaryColor);\n      @include fontSize(12);\n    }\n  }\n\n  .emailSent {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n\n    p {\n      font-size: 16px !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `ForgotPassword_scroll__K4EXS`,
	"SignIn": `ForgotPassword_SignIn__Iu1dd`,
	"loginBox": `ForgotPassword_loginBox__UWLKk`,
	"succecs": `ForgotPassword_succecs__AB7q6`,
	"alert": `ForgotPassword_alert__hu4WB`,
	"form": `ForgotPassword_form__XhwhO`,
	"top": `ForgotPassword_top__tccoO`,
	"field": `ForgotPassword_field__EWl--`,
	"field_top": `ForgotPassword_field_top__3ta54`,
	"errors": `ForgotPassword_errors__WaNwY`,
	"button_Box": `ForgotPassword_button_Box__Uo+Ef`,
	"emailSent": `ForgotPassword_emailSent__WaL1v`
};
export default ___CSS_LOADER_EXPORT___;
